// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/app/pagecontainer/modules/chats/components/chatlist/index.scss
// module id = 2365
// module chunks = 13